/* eslint-disable no-case-declarations */
/* eslint-disable no-param-reassign */
/* eslint-disable prefer-object-spread */
/* eslint-disable import/no-unresolved */
/* eslint-disable no-useless-constructor */

import {
  fetchMessages as GBC_fetchMessages,
  sendMessage as GBC_sendMessage,
  acknowledgeAllMessages as GBC_acknowledgeAllMessages,
} from '@sgorg/game-backend-client';

/**
 * Class for handling messages sent through the game-backend.
 */
export class OMT_MessageService {
  /**
   * constructor
   */
  constructor() {
    //
  }

  /**
   * get messages from the game-backend
   */
  async loadMessages() {
    try {
      const messages = await GBC_fetchMessages();
      console.log('MESSAGES RECEIVED : ', messages);
      messages.forEach((message) => {
        this.handleMessage(message);
      });
      GBC_acknowledgeAllMessages();
    } catch (e) {
      console.error('OMT_MessageService: Failed to get messages from the game-backend.');
    }
  }

  /**
   * handle individual messages
   * @param {Object} message
   */
  handleMessage(message) {
    if (!message.payload || !message.payload.messageType) return;
    const { messageType } = message.payload;
    switch (messageType) {
      case 'friendJoined':
        G.saveState.friendshipChestDataManager.setFriendCard(message.senderUserId, message.payload);
        break;
      case 'gateHereKey':
        const gatePayload = message.payload;
        const { gatesMgr } = G.Helpers;
        const result = gatesMgr.addGateInvite(
          gatePayload.gateId,
          gatePayload.sender,
          gatePayload.senderAvatar,
        );
        if (result.inviteAccepted) {
          gatesMgr.unlockGate(gatePayload.gateId);
        }
        break;
      default:
        break;
    }
  }

  /**
   * send a message / payload to the specified userId
   * @param {string} userId
   * @param {string} messageType
   * @param {Object} payload
   */
  async sendMessage(userId, messageType, payload) {
    // clone the payload object and assign the message type and FB userdata
    payload = Object.assign({
      messageType,
      senderUserData: OMT.envData.settings.user,
    }, payload);

    try {
      await GBC_sendMessage({ userId, payload });
    } catch (error) {
      console.error('OMT_MessageService: Failed to send message to game-backend.');
    }
  }
}
